import { render, staticRenderFns } from "./PosterModal.vue?vue&type=template&id=1307ac49&scoped=true&"
import script from "./PosterModal.vue?vue&type=script&lang=js&"
export * from "./PosterModal.vue?vue&type=script&lang=js&"
import style0 from "./PosterModal.vue?vue&type=style&index=0&id=1307ac49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1307ac49",
  null
  
)

export default component.exports